import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import supportTicketService from "../services/supportTicketService";

export function loadSupportTicketSuccess(supportTickets) {
  return {
    type: types.LOAD_SUPPORT_TICKETS_SUCCESS,
    supportTickets,
    meta: {
      throttle: true
    }
  };
}

export function getSupportTicketSuccess(supportTicket) {
  return {
    type: types.GET_SUPPORT_TICKET_SUCCESS,
    supportTicket
  };
}

export function clearSupportTicketSuccess() {
  return {
    type: types.CLEAR_SUPPORT_TICKET_SUCCESS
  };
}

export function savingSupportTicket(status = true) {
  return {
    type: types.SAVING_SUPPORT_TICKET,
    savingSupportTicket: status
  };
}

export function loadSupportTicketsBoardSuccess(supportTicketsBoard) {
  return {
    type: types.LOAD_SUPPORT_TICKETS_BOARD_SUCCESS,
    supportTicketsBoard,
    meta: {
      throttle: true
    }
  };
}

export function updateSupportTicketSuccess(supportTicket) {
  return {
    type: types.UPDATE_SUPPORT_TICKET_SUCCESS,
    supportTicket,
    meta: {
      throttle: true
    }
  };
}

export function loadSupportTickets(body, callDispatch) {
  return (dispatch) =>
    supportTicketService
      .loadSupportTickets(body)
      .then((data) =>
        callDispatch ? dispatch(loadSupportTicketSuccess(data)) : data
      )
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getSupportTicket(id, showSupportTicketDetails = false) {
  return (dispatch) =>
    supportTicketService
      .getSupportTicket(id)
      .then(({ supportTicket, totalBillableHours }) => {
        const orderedInformation = {
          ...supportTicket,
          totalBillableHours,
          audit_log:
            Array.isArray(supportTicket.audit_log) &&
            supportTicket.audit_log.length
              ? supportTicket.audit_log.sort(
                  (a, b) =>
                    new Date(b.created_on).getTime() -
                    new Date(a.created_on).getTime()
                )
              : []
        };
        dispatch(getSupportTicketSuccess(orderedInformation));
        if (showSupportTicketDetails) {
          dispatch(showModalSuccess("Support Ticket Modal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function updateSupportTicket(
  supportTicket,
  BULK = false,
  hideModal = false
) {
  return (dispatch) =>
    supportTicketService
      .updateSupportTicket(supportTicket)
      .then((updatedSupportTicket) => {
        dispatch(updateSupportTicketSuccess(updatedSupportTicket));
        dispatch(
          showAlertSuccess(
            `${
              BULK ? "Support Tickets" : "Support Ticket"
            } updated successfully`,
            "success"
          )
        );
        if (hideModal) {
          dispatch(hideModalSuccess(hideModal));
        }
        return updatedSupportTicket;
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadTicketsByCustomerId(id) {
  return (dispatch) =>
    supportTicketService
      .loadTicketsByCustomerId(id)
      .then((data) => dispatch(loadSupportTicketSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getSupportTicketModal(id, showTicketDetail = null) {
  return (dispatch) =>
    supportTicketService
      .getSupportTicket(id)
      .then((ticket) => {
        dispatch(getSupportTicketSuccess(ticket));
        if (showTicketDetail) {
          dispatch(showModalSuccess(showTicketDetail));
        }
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function clearSupportTicketReducer() {
  return (dispatch) => dispatch(loadSupportTicketSuccess([]));
}

export function setSupportTicketsBoardReducer(supportTicketsBoard) {
  return (dispatch) =>
    dispatch(loadSupportTicketsBoardSuccess(supportTicketsBoard));
}

export function addAuditLog(id, auditLog) {
  return (dispatch) =>
    supportTicketService
      .addAuditLog(id, auditLog)
      .then((ticket) => {
        dispatch(getSupportTicketSuccess(ticket));
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function getIsTicketResolvable(id) {
  return (dispatch) =>
    supportTicketService
      .getIsTicketResolvable(id)
      .then((data) => data)
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function clearSupportTicket() {
  return (dispatch) => dispatch(clearSupportTicketSuccess());
}
